import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import OrderService from "../services/OrderService";

const useOrderService = () => {
  const { client } = useApiContext();
  const service = useMemo(() => {
    return new OrderService(client);
  }, [client]);

  return service;
};

export default useOrderService;
